import { ProductCategory } from "@utils/constants";
import { DEFAULT_CERT_ICON_NAME } from "@utils/certificateIcons";
import { VDBIcons } from "@utils/VDBIcons";

export const getProductLevelColor = (productType: string) => {
  switch (productType) {
    case ProductCategory.DIAMOND:
      return "diam-03";
    case ProductCategory.GEMSTONE:
      return "gem-03";
    case ProductCategory.JEWELRY:
      return "jewelry-03";
    case ProductCategory.LAB_GROWN_DIAMOND:
      return "lab-03";
    default:
      return "diam-03";
  }
};

export const getProductBorderColor = (productType: string) => {
  switch (productType) {
    case ProductCategory.DIAMOND:
      return "diam-04";
    case ProductCategory.GEMSTONE:
      return "gem-04";
    case ProductCategory.JEWELRY:
      return "jewelry-04";
    case ProductCategory.LABGROWN_JEWELRY:
      return "jewelry-04";
    case ProductCategory.LAB_GROWN_DIAMOND:
      return "lab-04";
    default:
      return "diam-04";
  }
};

export const category = [
  {
    id: 1,
    title: "image",
    icon: VDBIcons.IMAGE,
  },
  {
    id: 2,
    title: "video",
    icon: VDBIcons.VIDEO,
  },
  {
    id: 3,
    title: "pdf",
    icon: DEFAULT_CERT_ICON_NAME,
  },
];
